import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import type { CarOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/motor';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';

export const useGetDMRCase = (): {
    getDMRCase: (registrationNumber: string) => Promise<CarOnsaDTO>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const getDMRCase = async (registrationNumber: string): Promise<CarOnsaDTO> => {
        return await OnlineSalesUnauthenticated.getDMRCase(
            jobNumber,
            sessionId,
            {
                regNumber: registrationNumber
            },
            !isLoggedOn
        );
    };

    return { getDMRCase };
};
